module.exports = __webpack_public_path__ + "static/media/tiktikithird.b0fa325e.png";